import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    EQP_ASSIGN_USER,
    EQP_ASSIGN_TECH_USER_LIST,
    EQP_ASSIGN_LIST,
    EQP_ASSIGN,
    EQP_ASSIGN_UNIT_HEALTH,
    EQP_ASSIGN_DELIVERY_ORDER,
    EQP_ASSIGN_EQUIPMENT,
    EQP_ASSIGN_DOCUMENT_TYPE,
    EQP_ASSIGN_USER_ASSIGN,
    EQP_ASSIGN_HISTORY
} from "../../actions";

import {
    EqpAssignUserSuccess,
    EqpAssignUserError,
    EqpAssignTechUserListSuccess,
    EqpAssignTechUserListError,
    EqpAssignUnitHealthSuccess,
    EqpAssignUnitHealthError,
    EqpAssignDeliveryOrderSuccess,
    EqpAssignDeliveryOrderError,
    EqpAssignEquipmentSuccess,
    EqpAssignEquipmentError,
    EqpAssignDocumentTypeSuccess,
    EqpAssignDocumentTypeError,
    EqpAssignUserAssignSuccess,
    EqpAssignUserAssignError,
    EqpAssignListSuccess,
    EqpAssignListError,
    EqpAssignSuccess,
    EqpAssignError,
    EqpAssignHistorySuccess,
    EqpAssignHistoryError
} from '../../actions';

export function* watchEqpAssignUser() {
    yield takeEvery(EQP_ASSIGN_USER, onEqpAssignUser);
}

export function* watchEqpAssignTechUserList() {
    yield takeEvery(EQP_ASSIGN_TECH_USER_LIST, onEqpAssignTechUserList);
}

export function* watchEqpAssignUnitHealth() {
    yield takeEvery(EQP_ASSIGN_UNIT_HEALTH, onEqpAssignUnitHealth);
}
export function* watchEqpAssignDeliveryOrder() {
    yield takeEvery(EQP_ASSIGN_DELIVERY_ORDER, onEqpAssignDeliveryOrder);
}
export function* watchEqpAssignEquipment() {
    yield takeEvery(EQP_ASSIGN_EQUIPMENT, onEqpAssignEquipment);
}
export function* watchEqpAssignDocumentType() {
    yield takeEvery(EQP_ASSIGN_DOCUMENT_TYPE, onEqpAssignDocumentType);
}
export function* watchEqpAssignUserAssign() {
    yield takeEvery(EQP_ASSIGN_USER_ASSIGN, onEqpAssignUserAssign);
}

export function* watchEqpAssignList() {
    yield takeEvery(EQP_ASSIGN_LIST, onEqpAssignList);
}

export function* watchEqpAssign() {
    yield takeEvery(EQP_ASSIGN, onEqpAssign);
}

export function* watchEqpAssignHistory() {
    yield takeEvery(EQP_ASSIGN_HISTORY, onEqpAssignHistory);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onEqpAssignUserAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'assignTechnic/user', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignTechUserListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/technic', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignUnitHealthAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/unithealth', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignEquipmentAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/equipment', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignDocumentTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/documenttype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignUserAssignAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/userassign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/equipmentlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assignTechnic/assign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onEqpAssignHistoryAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'assignTechnic/assignhistory', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onEqpAssignUser(data) {
    try {
        const response = yield call(onEqpAssignUserAsync, data.payload);
        yield put(EqpAssignUserSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignUserError(error));
    }
}

function* onEqpAssignTechUserList(data) {
    try {
        const response = yield call(onEqpAssignTechUserListAsync, data.payload);
        yield put(EqpAssignTechUserListSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignTechUserListError(error));
    }
}

function* onEqpAssignUnitHealth(data) {
    try {
        const response = yield call(onEqpAssignUnitHealthAsync, data.payload);
        yield put(EqpAssignUnitHealthSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignUnitHealthError(error));
    }
}

function* onEqpAssignDeliveryOrder(data) {
    try {
        const response = yield call(onEqpAssignDeliveryOrderAsync, data.payload);
        yield put(EqpAssignDeliveryOrderSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignDeliveryOrderError(error));
    }
}

function* onEqpAssignEquipment(data) {
    try {
        const response = yield call(onEqpAssignEquipmentAsync, data.payload);
        yield put(EqpAssignEquipmentSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignEquipmentError(error));
    }
}

function* onEqpAssignDocumentType(data) {
    try {
        const response = yield call(onEqpAssignDocumentTypeAsync, data.payload);
        yield put(EqpAssignDocumentTypeSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignDocumentTypeError(error));
    }
}

function* onEqpAssignUserAssign(data) {
    try {
        const response = yield call(onEqpAssignUserAssignAsync, data.payload);
        yield put(EqpAssignUserAssignSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignUserAssignError(error));
    }
}

function* onEqpAssignList(data) {
    try {
        const response = yield call(onEqpAssignListAsync, data.payload);
        yield put(EqpAssignListSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignListError(error));
    }
}

function* onEqpAssign(data) {
    try {
        const response = yield call(onEqpAssignAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(EqpAssignSuccess(response.data));
    } catch (error) {
        yield put(EqpAssignError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onEqpAssignHistory(data) {
    try {
        const response = yield call(onEqpAssignHistoryAsync, data.payload);
        yield put(EqpAssignHistorySuccess(response.data));
    } catch (error) {
        yield put(EqpAssignHistoryError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchEqpAssignUser),
        fork(watchEqpAssignTechUserList),
        fork(watchEqpAssignUnitHealth),
        fork(watchEqpAssignDeliveryOrder),
        fork(watchEqpAssignEquipment),
        fork(watchEqpAssignDocumentType),
        fork(watchEqpAssignUserAssign),
        fork(watchEqpAssignList),
        fork(watchEqpAssign),
        fork(watchEqpAssignHistory)
    ]);
}